// extracted by mini-css-extract-plugin
export default {"Root":"Day_Root__2OOWp","Title":"Day_Title__VfjNd","List":"Day_List__ETI+Z"};